import React, { useMemo } from "react";
import DashboardMrtTable from "./DashboardMrtTable";
import { DASHBOARD_EMPHASIS_CELL_SX } from "./dashboardTableStyles";
import {
  formatDaysCount,
  formatHoursCount,
  getPriorityTone,
} from "../../utils/dashboardUtils";

const PriorityBadge = ({ priority }) => {
  const tone = getPriorityTone(priority);

  return (
    <span className={`dashboard-priority dashboard-priority--${tone}`}>
      <span className="dashboard-priority-dot" aria-hidden="true" />
      {priority}
    </span>
  );
};

const OverdueTasksTable = ({ rows = [], onOwnerClick, onTagClick, isLoading = false }) => {
  const columns = useMemo(
    () => [
      {
        accessorKey: "task",
        header: "Task",
        size: 200,
        muiTableBodyCellProps: { sx: DASHBOARD_EMPHASIS_CELL_SX },
      },
      {
        accessorKey: "owner",
        header: "Owner",
        size: 120,
        Cell: ({ row }) => (
          <button
            type="button"
            className="dashboard-person-link"
            onClick={() => onOwnerClick?.(row.original)}
          >
            {row.original.owner}
          </button>
        ),
      },
      {
        accessorKey: "tag",
        header: "Tag",
        size: 150,
        Cell: ({ row }) => (
          <button
            type="button"
            className="dashboard-person-link"
            onClick={() => onTagClick?.(row.original)}
          >
            {row.original.tag}
          </button>
        ),
      },
      {
        accessorKey: "priority",
        header: "Priority",
        size: 120,
        Cell: ({ row }) => <PriorityBadge priority={row.original.priority} />,
      },
      {
        accessorKey: "dueDate",
        header: "Due Date",
        size: 100,
      },
      {
        accessorKey: "daysOverdue",
        header: "Days Overdue",
        size: 120,
        muiTableBodyCellProps: { sx: DASHBOARD_EMPHASIS_CELL_SX },
        Cell: ({ row }) => formatDaysCount(row.original.daysOverdue),
      },
      {
        accessorKey: "taskAge",
        header: "Task Age",
        size: 100,
        Cell: ({ row }) => formatDaysCount(row.original.taskAge),
      },
      {
        accessorKey: "hours",
        header: "Hours",
        size: 80,
        Cell: ({ row }) => formatHoursCount(row.original.hours),
      },
    ],
    [onOwnerClick, onTagClick]
  );

  return (
    <section className="dashboard-section dashboard-section--table">
      <h3 className="dashboard-section-title">All Overdue Tasks — Sorted by Age</h3>
      <DashboardMrtTable
        className="dashboard-overdue-table"
        columns={columns}
        data={rows}
        isLoading={isLoading}
        emptyMessage="No overdue tasks."
        unitName="tasks"
        initialSorting={[{ id: "daysOverdue", desc: true }]}
        scrollContainer={false}
        tableContainerFitContent
      />
    </section>
  );
};

export default OverdueTasksTable;
